import styled from '@emotion/styled';
import H3 from '@base/H3/H3';
import Paper from '@base/Paper/Paper';
import { Fonts, Spacings, mediaQuery } from '@styles/index';
import Image from '@base/Image';
import Breadcrumbs from '@cont/Quiz/Common/Breadcrumbs';
import { useRouter } from 'next/router';
import useGoalInfo from '@api/hooks/goal/useGoalInfo';
import Actions from './Actions';
import Stats from './Stats';
import Tags from './Tags';

const Wrapper = styled(Paper)`
  grid-column: span 24;
  padding: ${Spacings.SPACING_10B} ${Spacings.SPACING_12B};
  height: fit-content;

  ${mediaQuery.uptoTablet} {
    grid-column: auto;
    width: 100%;
  }

  ${mediaQuery.uptoMobile} {
    grid-column: auto;
    width: 100%;
    padding: ${Spacings.SPACING_4B};
  }
`;
const TagBack = styled.div`
  display: block;
  ${mediaQuery.uptoMobile} {
    display: none;
  }
`;
const Header = styled.div`
  grid-column: span 24;
  margin: ${Spacings.SPACING_4B} 0 ${Spacings.SPACING_9B} 0;
  ${mediaQuery.uptoMobile} {
    display: none;
  }
`;

const MwebHeader = styled.div`
  ${mediaQuery.aboveMobile} {
    display: none;
  }
  font-size: ${Fonts.H3};
  font-weight: ${Fonts.SEMIBOLD};
  margin-top: ${Spacings.SPACING_2B};
`;

const Flex = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const ContentWrapper = styled.div`
  width: 670px;

  ${mediaQuery.uptoMobile} {
    width: 100%;
  }
`;

const TestFlexWrapper = styled(Flex)`
  ${mediaQuery.uptoMobile} {
    flex-flow: column-reverse;
  }
`;

const IllustrationWrapper = styled.div`
  ${mediaQuery.uptoMobile} {
    padding: ${Spacings.SPACING_4B} ${Spacings.SPACING_0B};
  }
`;

const Description = ({ loading }) => {
  const router = useRouter();
  const {
    query: { goalUID }
  } = router;

  const { goalInfo: goalDetails } = useGoalInfo(goalUID);
  const goalName = goalDetails?.name || '';
  return (
    <Wrapper>
      <TagBack>
        <Breadcrumbs />
      </TagBack>
      <Tags />
      <MwebHeader>Scholarship Test for {goalName}</MwebHeader>
      <TestFlexWrapper>
        <ContentWrapper>
          <Header>
            <H3 as="h1">Scholarship Test</H3>
          </Header>
          <Stats />
          <Actions loading={loading} />
        </ContentWrapper>
        <IllustrationWrapper>
          <Image
            height={260}
            width={360}
            src="quiz/default-empty-mweb.svg"
            alt="default"
          />
        </IllustrationWrapper>
      </TestFlexWrapper>
    </Wrapper>
  );
};

export default Description;
